import { Component , OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpUtils } from 'common';

@Component({
    selector: 'migration-embed',
    template: require('./migration-embed.html')
})

export default class MigrationEmbed implements OnInit {

    public iframeUrl;
    constructor( private sanitizer: DomSanitizer) {
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${HttpUtils.getUiMountPoint()}/hcx-ui/resources/vm-migration/index-no-alerts.html`);
    }

    ngOnInit() {
    }
};



// WEBPACK FOOTER //
// ./src/app/components/migration/migration-embed.ts